import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
// import { useWeb3React } from "@web3-react/core";
// import web3 from 'web3';


// import Web3 from 'web3';

import { useAuth } from "../../hooks/useAuth";
import { useCore } from "../../hooks/useCore";
import { useWallet } from "../../hooks/useWallet";
import { useNavigator } from "../../hooks/useNavigator";

import { NFTItem } from "../../components/Wallet/NFTItem";
import { AssetToolbar } from "../../components/Wallet/AssetToolbar";

import { ProjectToolbar } from "../../components/Wallet/ProjectToolbar";

import { Helmet } from "react-helmet-async";

import { Layout } from "../../components/Layout";

import classNames from "classnames";

import ReactTooltip from 'react-tooltip';

import { chains } from "../../utils/data";
import { addCommas } from "../../utils/tools";
var FileSaver = require('file-saver');

export function NFTPortal() {

    let navigate = useNavigate();

    let { moralisInit,
        balances,
        transactions,
        transactionsMeta,
        nfts,
        fetchNFTs,
        fetchNFT,
        nft,
        nftProject,
        fetchBalances,
        fetchTransactions,
        walletAddress,
        chainTotalBalances,
        handleCheckingForNft,
        checkingForNft,
        fetchProjectAssets,
        assetCheck
    } = useWallet();

    // const { active, account, library, activate, deactivate } = useWeb3React();

    let { fullscreen, toggleFullscreen, handleModalVisible } = useCore();

    const navigator = useNavigator();

    let { contractAddress, handleContractAddress, screens } = useNavigator();

    const [ nftShow, setNftShow ] = useState(false);

    useEffect(() => {
        if(walletAddress && moralisInit){

        }

    }, [ walletAddress, moralisInit ]);


    useEffect(() => {
        if(checkingForNft && assetCheck == "empty"){
            handleModalVisible(true);
            navigator.push(`/`)
        }else if(checkingForNft && assetCheck){
            handleModalVisible(true);
            navigator.push(`/assets/${nft.asset_contract.address}/${nft.token_id}`)
        }

    }, [ assetCheck ]);


    useEffect(() => {
        console.log(window.location, window.location.hash, window.location.pathname)
        if(!nft){
            let ptemp = window.location.pathname;
            console.log(ptemp)
            ptemp = ptemp.substring(1);
            console.log(ptemp)
            let parray = ptemp.split('/');
            console.log(parray);
            if(parray[0] == "assets"){
                if( parray[1].indexOf('0x') > -1){
                    getNFT(parray[1],parray[2]);
                }else if(parray[1]=="check" && parray[2].indexOf('0x') > -1){
                    handleCheckingForNft(true);
                    fetchProjectAssets(parray[2]);
                }
            }

            // getNFT();
        }
        console.log('nft portal',navigator.screen);
    }, []);




    const getNFT = async (ca, tid) => {
        fetchNFT(ca, tid);
    }




    function onBreadCrumbClick(i){
        console.log(i)
        let path = [...screens].slice(0, (i+1)).join('/');
        navigator.push(path);
    }

    function onBack(){
        console.log('back button');
    }



    // const walletTruncated = account?.length ? account.substring(0,11) + '...' + account.substring(account.length - 7) : '';

    const pageTitle = nft && nft.id !== undefined ? `${nft.asset_contract.name} #${nft.token_id}` : 'Artemis';

    return (
        <Layout>

            <Helmet>
                <title>
                    {pageTitle}
                </title>
            </Helmet>

            { !nft || nft.collection == undefined ? (
                <div className="loader-spinner"/>
            ) :(

                <>



                    {navigator.screen.indexOf("assets/0x") > -1 ? (
                        <div className="nft-project presentation">


                            { nft && nft.asset_contract !== undefined && (
                                <div className="nft-stage-toolbar footer-toolbar coin-meta">

                                    <div className="coin-meta">
                                        <div className="coin-name">{nft.name} <span className="mute"> &nbsp;&nbsp;::&nbsp;&nbsp; </span></div>
                                        {/*<div className="coin-symbol">test</div>*/}
                                    </div>

                                    <AssetToolbar nft={nft} ca={nft.asset_contract.address}/>


                                </div>
                            )}


                            <div className={classNames(
                                "nft-project-header",
                                fullscreen ? "fullscreen" : null
                            )}>


                                { nft && nft.asset_contract !== undefined && (
                                    <div className="nft-stage-toolbar center top coin-meta">


                                        <div className="coin-meta">
                                            <div className="coin-name">{nft.name} <span className="mute"> &nbsp;&nbsp;::&nbsp;&nbsp; </span></div>
                                            {/*<div className="coin-symbol">test</div>*/}
                                        </div>

                                        <AssetToolbar nft={nft} ca={nft.asset_contract.address}/>


                                    </div>
                                )}


                                { nft && (

                                    <div style={{backgroundImage: `url(${nft.collection.banner_image_url})`}} className="nft-project-banner">

                                        <div className="nft-project-meta-column">
                                            <div className={classNames('nft-project-meta-container', 'transition', fullscreen && 'full')}>
                                                <div onClick={toggleFullscreen} style={{backgroundImage: `url(${nft.collection.image_url})`}} className="nft-project-image">

                                                </div>
                                                <div className="nft-project-meta">

                                                    <div className="flex-row">
                                                        <p className="nft-project-title">{nft.collection.name}</p>

                                                        { nft.collection.safelist_request_status == "verified" && (
                                                            <div className="svg-icon bluecheckmark">
                                                                <svg aria-label="verified-icon" class="sc-50keu7-0 eWEXKZ" fill="none" viewBox="0 0 30 30"><path d="M13.474 2.80108C14.2729 1.85822 15.7271 1.85822 16.526 2.80108L17.4886 3.9373C17.9785 4.51548 18.753 4.76715 19.4892 4.58733L20.9358 4.23394C22.1363 3.94069 23.3128 4.79547 23.4049 6.0278L23.5158 7.51286C23.5723 8.26854 24.051 8.92742 24.7522 9.21463L26.1303 9.77906C27.2739 10.2474 27.7233 11.6305 27.0734 12.6816L26.2903 13.9482C25.8918 14.5928 25.8918 15.4072 26.2903 16.0518L27.0734 17.3184C27.7233 18.3695 27.2739 19.7526 26.1303 20.2209L24.7522 20.7854C24.051 21.0726 23.5723 21.7315 23.5158 22.4871L23.4049 23.9722C23.3128 25.2045 22.1363 26.0593 20.9358 25.7661L19.4892 25.4127C18.753 25.2328 17.9785 25.4845 17.4886 26.0627L16.526 27.1989C15.7271 28.1418 14.2729 28.1418 13.474 27.1989L12.5114 26.0627C12.0215 25.4845 11.247 25.2328 10.5108 25.4127L9.06418 25.7661C7.86371 26.0593 6.6872 25.2045 6.59513 23.9722L6.48419 22.4871C6.42773 21.7315 5.94903 21.0726 5.24777 20.7854L3.86969 20.2209C2.72612 19.7526 2.27673 18.3695 2.9266 17.3184L3.70973 16.0518C4.10824 15.4072 4.10824 14.5928 3.70973 13.9482L2.9266 12.6816C2.27673 11.6305 2.72612 10.2474 3.86969 9.77906L5.24777 9.21463C5.94903 8.92742 6.42773 8.26854 6.48419 7.51286L6.59513 6.0278C6.6872 4.79547 7.86371 3.94069 9.06418 4.23394L10.5108 4.58733C11.247 4.76715 12.0215 4.51548 12.5114 3.9373L13.474 2.80108Z" class="sc-50keu7-1 jQQIn"></path><path d="M13.5 17.625L10.875 15L10 15.875L13.5 19.375L21 11.875L20.125 11L13.5 17.625Z" fill="white" stroke="white"></path></svg>

                                                            </div>
                                                        )}



                                                    </div>
                                                    { nft.collection.stats?.total_supply && (
                                                        <p className="nft-project-title-sub">{addCommas(nft.collection.stats.total_supply)} <span className="mute">items</span></p>
                                                    )}




                                                </div>
                                            </div>
                                            {nftProject && (
                                                <div className="nft-stage-toolbar bottom">
                                                    <ProjectToolbar/>
                                                </div>
                                            )}

                                        </div>
                                    </div>
                                )}


                            </div>
                            <div className="nft-stage-container">

                                <div className="nft-stage">
                                    { nft && (
                                        <NFTItem ca={contractAddress} includeInfo={false} nft={nft}/>
                                    )}
                                </div>
                            </div>
                        </div>


                    ) : (

                        <>

                            {navigator.screen.indexOf("assets/collection") > -1 && (
                                <>
                                    <p>collection</p>
                                    { nfts && (
                                        <div className="nft-container">
                                        <p>test</p>
                                            {/*<ResponsiveMasonry style={{ width: '100%'}}
                                                columnsCountBreakPoints={{350: 1, 550: 2, 900: 3, 1150: 4}}
                                            >
                                                <Masonry>
                                                    { Object.keys(nfts).map((key, i) => (
                                                        <NFTProjectCard passClick={nftProjectClick} nftp={nfts[key]} key={i}/>
                                                    ))}
                                                </Masonry>
                                            </ResponsiveMasonry>
        */}
                                        </div>
                                    )}
                                </>
                            )}




                        </>

                    )}


                </>
            ) }



        </Layout>
    );
}
